import TemplateTag from '../TemplateTag';
import stripIndentTransformer from '../stripIndentTransformer';
import trimResultTransformer from '../trimResultTransformer';
var stripIndent = new TemplateTag(stripIndentTransformer, trimResultTransformer);
export default stripIndent;